import PropTypes from 'prop-types';
import React, {Component} from 'react';
import OddscheckerWidget from 'modules/Common/components/OddscheckerWidget';
import config from 'config';
import {has} from 'utils/features';

class AdvertWrapper extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hasOddscheckerIntegration: false,
        }
    }

    componentDidMount() {
        this.setState({
            hasOddscheckerIntegration: has("oddschecker-integration")
        });
    }

    getSlot(conf, slotArray){
        if (!conf) {
          return;
        }

        let innerSlots = slotArray.slice();
        if (innerSlots.length === 0){
            return conf;
        }
        let element = innerSlots.shift();
        return this.getSlot(conf[element], innerSlots);
    }

    render() {
        const ocIdConfig = config.oddschecker.slotID;
        let ocId = this.getSlot(ocIdConfig, this.props.ocSlot);

        const showOddsChecker = ocId && this.state.hasOddscheckerIntegration;

      return showOddsChecker ? <OddscheckerWidget hash={ocId} isFooter={this.props.isFooter}/> : <div className="ocwPlaceholder" />;
    }
}

AdvertWrapper.propTypes = {
    isFooter: PropTypes.bool,
    ocSlot: PropTypes.array,
    additionalProperties: PropTypes.object
};

AdvertWrapper.defaultProps = {
    isFooter: false,
    ocSlot: [],
};

export default AdvertWrapper;



// WEBPACK FOOTER //
// ./modules/Common/components/AdvertWrapper.js